import { AppTypeDentalOrVision, DentalAndVisionApplication } from '@/application/shared/domain/DentalAndVisionApplication';
import { EnrollmentRepository } from '@/application/shared/domain/EnrollmentRepository';
import { UseCase } from '@/shared/application/UseCase';
import { SfApiResponse } from '@hfc/ui-core';

export class SubmitApplicationUseCase implements UseCase<[AppTypeDentalOrVision, DentalAndVisionApplication], SfApiResponse<string>> {

  private repository: EnrollmentRepository;

  public constructor (repository: EnrollmentRepository) {
    this.repository = repository;
  }

  public async run (params: [AppTypeDentalOrVision, DentalAndVisionApplication]): Promise<SfApiResponse<string>> {
    const [applicationType, application] = params;

    return await this.repository.submitDentalAndVisionApplication(applicationType, application);
  }

}
